import column from '../../../../common/list-table/helpers/columns';

export default (data) => {
  const { FilteredTextColumn } = column(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Device type', 'mrdType').withWidth(100),
        new FilteredTextColumn('Screen', 'screen').withWidth(200),
        new FilteredTextColumn('Key', 'key'),
        new FilteredTextColumn('Original text', 'originalValue'),
        new FilteredTextColumn('Translated text', 'translatedValue'),
      ],
    },
  ];
};

export const editIpcColumns = (data, setData) => {
  const { FilteredTextColumn, EditableTextColumn } = column(data);

  const validateInput = (input) => input.replace(/\n/g, '');

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('MRD type', 'mrdType').withWidth(100),
        new FilteredTextColumn('Screen', 'screen').withWidth(200),
        new FilteredTextColumn('Key', 'key'),
        new EditableTextColumn('Original text', 'originalValue', true, data, setData, validateInput),
        new EditableTextColumn('Translated text', 'translatedValue', true, data, setData, validateInput),
      ],
    },
  ];
};

export const editColumns = (data, setData) => {
  const { FilteredTextColumn, EditableTextColumn } = column(data);

  const validateInput = (input) => input.replace(/\n/g, '');

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('MRD type', 'mrdType').withWidth(100),
        new FilteredTextColumn('Screen', 'screen').withWidth(200),
        new FilteredTextColumn('Key', 'key'),
        new FilteredTextColumn('Original text', 'originalValue'),
        new EditableTextColumn('Translated text', 'translatedValue', true, data, setData, validateInput),
      ],
    },
  ];
};
